import React, { useRef, useCallback, useMemo } from "react";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import { upload } from "../../lib/hooks/useSocket";

interface QuillWithSocketUploadProps {
  value: string;
  onChange: (content: string) => void;
}

const QuillWithSocketUpload: React.FC<QuillWithSocketUploadProps> = ({
  value,
  onChange,
}) => {
  const quillRef = useRef<any>(null);

  const handleImageUpload = useCallback(() => {
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();

    input.onchange = async () => {
      if (!input.files || input.files.length === 0) return;

      const file = input.files[0];
      const reader = new FileReader();

      reader.onload = async () => {
        const base64 = (reader.result as string).split(",")[1];
        try {
          const uploadedFiles = await upload([
            {
              file: base64,
              filename: file.name,
            },
          ]);

          if (!uploadedFiles || uploadedFiles.length === 0) return;

          const uploadedFile = uploadedFiles[0];

          const quill = quillRef.current.getEditor();
          const range = quill.getSelection(true);
          quill.insertEmbed(range.index, "image", uploadedFile.absolutePath);

          quill.setSelection(range.index + 1);

          onChange(quill.root.innerHTML);
        } catch (error) {
          console.error("Upload failed", error);
        }
      };

      reader.readAsDataURL(file);
    };
  }, [onChange]);

  const modules = useMemo(
    () => ({
      toolbar: {
        container: [
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          [{ font: [] }, { size: ["small", false, "large", "huge"] }],
          ["bold", "italic", "underline", "strike", "blockquote"],
          [{ script: "sub" }, { script: "super" }],
          [{ color: [] }, { background: [] }],
          ["link", "image"],
          [{ align: [] }],
          [{ list: "ordered" }, { list: "bullet" }],
          [{ indent: "-1" }, { indent: "+1" }],
          ["clean"],
        ],
        handlers: {
          image: handleImageUpload,
        },
      },
    }),
    [],
  );

  return (
    <ReactQuill
      ref={quillRef}
      theme="snow"
      modules={modules}
      value={value}
      onChange={onChange}
    />
  );
};

export default QuillWithSocketUpload;
